import {
  createDetailTableRangeFilter,
  DetailTableRangeFilterRef,
  RangeFilterConditionType,
  RangeFilterModel
} from './DetailTableRangeFilter';

type NumericRangeFilterCondition = {
  filterType: 'number';
  type: RangeFilterConditionType;
  filter: number;
};

export type NumericRangeFilterModel = RangeFilterModel<'number', NumericRangeFilterCondition>;

export type DetailTableNumericRangeFilterRef = DetailTableRangeFilterRef<NumericRangeFilterModel>;

function toFiniteOrNull(rawInput: string): number | null {
  if (rawInput === '') return null;
  const parsed = Number(rawInput);
  return Number.isFinite(parsed) ? parsed : null;
}

// 'equal' restores the exact-match operator that ag-grid v28 offered before the v34
// upgrade (see BUD-15663) — the backend has always supported it (applyFilter.ts).
export const DetailTableNumericRangeFilter = createDetailTableRangeFilter<
  'number',
  NumericRangeFilterCondition,
  number
>({
  displayName: 'DetailTableNumericRangeFilter',
  name: 'numeric-range',
  filterType: 'number',
  inputType: 'number',
  createCondition: (type, filter) => ({ filterType: 'number', type, filter }),
  readConditionInput: (condition) => String(condition.filter),
  parseInput: toFiniteOrNull,
  isInvertedRange: (from, to) => from > to
});
